// extracted by mini-css-extract-plugin
export default {"cancelBtn":"ModalButtons_cancelBtn__7rFP5","addBtn":"ModalButtons_addBtn__hFFZl"};